import { render, staticRenderFns } from "./accInfoDc.vue?vue&type=template&id=2ab5bd08&scoped=true"
import script from "./accInfoDc.vue?vue&type=script&lang=js"
export * from "./accInfoDc.vue?vue&type=script&lang=js"
import style0 from "./accInfoDc.vue?vue&type=style&index=0&id=2ab5bd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5bd08",
  null
  
)

export default component.exports